import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import AddEditFrieghtAmount from '../../../components/Trip/AddEditFrieghtAmount';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:"0 24px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    justifyContent:'space-between',
    boxShadow:'none'
  },
  icon:{
    fontSize:16,
    color:'#03c',
    cursor:'pointer'
  },
  listLabel:{
    fontSize:16,
    fontWeight:600,
    color:'#0b1323'
  },
  amount:{
    color:'#03c',
    fontWeight:600,
    fontSize:16,
    marginRight:24
  }
}));
const JourneyTripFreightCard = (props) => {
  const {trip,journey,updateJourney} = props;
  const classes = useStyles();
  let history = useHistory();
  let transactions = trip && trip.transactions && trip.transactions.freight ? trip.transactions.freight :[];
  const [addEditFreightOpen,setAddEditFrieghtOpen] = useState(false)
  const handleAddEditFrightClose = () => {
    setAddEditFrieghtOpen(false);
  }
  const handleAddEditFrightSave = () => {
    setAddEditFrieghtOpen(false);
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
          {transactions && transactions.list && transactions.list.map((trans,index)=>{
              return <>
                  <Typography className={classes.listLabel}>Freight Amount</Typography>
                  <Box display="flex" alignItems="center">
                    <Typography className={classes.amount}>{numberFormat(trans.amount)}</Typography>
                    <EditIcon onClick={()=>{setAddEditFrieghtOpen(true)}} className={classes.icon}/>
                  </Box>
              </>
          })}
      </Paper>
      {addEditFreightOpen && <AddEditFrieghtAmount freight={transactions} selectedTrip={trip} updateJourney={updateJourney} open={addEditFreightOpen} onClose={handleAddEditFrightClose} onSave={handleAddEditFrightSave} />}
    </>
  );
}
export default JourneyTripFreightCard;